import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";
import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";

function ServiceGroups() {
  const [GroupName, setGroupName] = useState("");
  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [gettservice, setGettService] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [GroupStatus, setStatus] = useState("");
  const [editItemId, setEditItemId] = useState(null);

  const getServiceGroup = async () => {
    try {
      const response = await privateRequest.get(
        `ServiceGroup/ServiceGroupByStatus`
      );
      setGettService(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getParentCategory = async () => {
    try {
      const response = await privateRequest.get(
        `ParentCategory/Parentcategory`
      );
      setParentCategoryGroups(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteServiceGroup = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `ServiceGroup/DeleteServiceGroup/${_id}`
        );
        getServiceGroup();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const AddServiceGroup = async (event) => {
    try {
      const formData = {
        GroupName: GroupName,
        Status: GroupStatus,
        PCName: selectedGroup.map((group) => group.value), // Use group.value instead of group.label
      };

      if (editItemId) {
        await privateRequest.put(
          `ServiceGroup/UpdateServiceGroup/${editItemId}`,
          formData
        );
      } else {
        await privateRequest.post(`ServiceGroup/AddServiceGroup`, formData);
      }

      getServiceGroup();

      setGroupName("");
      setSelectedGroup([]);
      setStatus("");
      setEditItemId(null);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Service group saved successfully!",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getServiceGroup();
    getParentCategory();
  }, []);

  return (
    <>
      {gettservice?.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}

      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Service Group</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      onClick={() => {
                        setEditItemId(null);
                        setGroupName("");
                        setSelectedGroup([]);
                        setStatus("");
                        // setEditItemId(null);
                      }}
                      data-toggle="modal"
                      data-target="#addAreaModal"
                      role="button"
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">Group Name</th>
                            <th scope="col">P. Cat</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gettservice?.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.GroupName}
                              </td>
                              <td className="align-center">
                                {(item?.PCName || []).map((category, i) => (
                                  <span
                                    key={i}
                                    className="badge badge-primary mr-2"
                                  >
                                    {category.PCName}
                                  </span>
                                ))}
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    item?.Status === "0"
                                      ? "badge-danger"
                                      : "badge-primary"
                                  }`}
                                >
                                  {item?.Status === "1" ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <p className="mb-0">{item.createdBy?.name}</p>
                                <p className="mb-0">
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-US",
                                    {
                                      day: "numeric",
                                      month: "long",
                                      year: "numeric",
                                    }
                                  )}
                                </p>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEditItemId(item._id);
                                      setGroupName(item.GroupName);
                                      setSelectedGroup(
                                        item.PCName.map((category) => ({
                                          value: category._id,
                                          label: category.PCName,
                                        }))
                                      );
                                      setStatus(item.Status);
                                    }}
                                    data-toggle="modal"
                                    data-target="#addAreaModal"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteServiceGroup(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        class="modal fade"
        id="addAreaModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Service Group
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={AddServiceGroup}>
                <div className="form-group">
                  <label className="mb-0">Group Name</label>
                  <input
                    type="text"
                    id="inputgroupName"
                    className="form-control"
                    placeholder="Group Name"
                    value={GroupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Parent Category</label>
                  <Select
                    isMulti
                    options={parentCategory.map((group) => ({
                      value: group._id,
                      label: group.PCName,
                    }))}
                    onChange={(selectedOptions) =>
                      setSelectedGroup(selectedOptions)
                    }
                    value={selectedGroup}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-0">Status</label>
                  <select
                    className="form-control"
                    value={GroupStatus}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <button
                    onClick={() => {
                      AddServiceGroup();
                    }}
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    className="btn btn-primary"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceGroups;
